<template>
  <div class="container-fluid clinic-pharmaceuticals mt-3">
    <clinic-show-pharma ref="showpharma" @submit="getPharmaceuticals(1)"></clinic-show-pharma>
    <div class="row">
      <div class="col-sm-4">
        <h1 class="page-title">LISTADO DE FÁRMACOS</h1>
      </div>
      <div class="col-sm-5">
        <input v-model="search" class="form-control icon" type="search" name="search" id="pharma_index_search"
          placeholder="Busca el nombre del fármaco">
      </div>
      <div class="col-sm-2">
        <button class="btn btn-wabident-round btn-block mt-1" @click="createPharmaceutical">
          Añadir nuevo ...
        </button>
      </div>
    </div>

    <div class="row" v-if="has_results">
      <div class="col-md-12">
        <table class="table">
          <thead>
            <tr>
              <th>#VADEMECUM</th>
              <th>FECHA</th>
              <th>NOMBRE</th>
              <th>FORMA</th>
              <th>UDS. ENVASE</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="pharma in pharmaceuticals.data" :key="pharma.id" @click="editPharmaceutical(pharma)">
              <td>{{ pharma.vademecum_id }}</td>
              <td>{{ formatDate(pharma.created_at) }}</td>
              <td>{{ pharma.title }}</td>
              <td>{{ pharma.form }}</td>
              <td>{{ pharma.units }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row" v-if="has_results">
      <div class="col-md-12">
        <data-pagination @gotopage="getPharmaceuticals" :page="pharmaceuticals.current_page"
          :total="pharmaceuticals.last_page"></data-pagination>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      is_loading: false,
      pharmaceuticals: null,
    }
  },
  watch: {
    search(val) {
      this.getPharmaceuticals();
    },
  },
  computed: {
    has_results() {
      return this.pharmaceuticals;
    },
    ...mapGetters(['clinic', 'msgwindow', 'errowindow'])
  },
  methods: {
    formatDate(date) {
      return WabiDent.fmtDate(date);
    },
    createPharmaceutical() {
      return this.$refs.showpharma.showNew();
    },
    editPharmaceutical(pharma) {
      return this.$refs.showpharma.showEdit(pharma);
    },
    getPharmaceuticals(page = 1) {
      this.is_loading = true;

      let url = `/clinic/${this.clinic.id}/pharmaceuticals`;
      let params = {
        page: page,
        search: this.search
      };

      axios.get(url, { params }).then((response) => {
        this.pharmaceuticals = response.data;
      }).catch((error) => {
        this.msgwindow.error('Error cargando fármacos');
      }).then(() => {
        this.is_loading = false;
      });
    },
  },
  mounted() {
    this.getPharmaceuticals();
  }
};
</script>

<style lang="scss">
.clinic-pharmaceuticals {
  .table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    font-size: 15px;
    letter-spacing: 0.3px;
    color: var(--theme-grey);
    border: none;
    position: sticky;
    background-color: white;
    top: 0;
  }

  .table tbody tr {
    transition: background-color .3s;
    cursor: pointer;

    &:hover {
      background-color: var(--theme-shadow);
    }
  }

}
</style>
